import dayjs from "dayjs";
import { html } from "lit-html";
import { DEFAULT_DATE_FORMAT } from "Services/constants";
import { useEffectWithCleanup } from "Shared/haunted/CustomHooks";

export interface Props {
	culture: string;
}

export const useHotelsTab = (props: Props) => {
	const loadBookingWidget = () => {
		const script = document.createElement("script");
		script.type = "text/javascript";
		script.id = "sp_widget";
		script.dataset.hash = "_c9acebd4a3070ea70";
		script.dataset.container = "hotel_container";
		script.dataset.size = "400x320";
		script.dataset.tpncy = "false";

		const checkin = dayjs().format(DEFAULT_DATE_FORMAT);
		const checkout = dayjs().add(1, "day").format(DEFAULT_DATE_FORMAT);
		const lang = props.culture.split("-")[0].toLowerCase();

		script.src = `https://cf.bstatic.com/static/affiliate_base/js/booking_sp_widget.js?checkin=${checkin}&checkout=${checkout}&iata_orr=1&iata=SCL&lang=${lang}`;

		document.body.appendChild(script);
	};

	useEffectWithCleanup(() => {
		const elem = document.getElementById("hotel_container");
		if (elem && !elem.children?.length) {
			loadBookingWidget();
		}

		return () => {
			document.getElementById("sp_widget")?.remove();
		};
	});

	const htmlTemplate = () => html` <div id="hotel_container"></div> `;

	return { htmlTemplate };
};
